import styled from 'styled-components';
import { DealerCommentStyled } from '../DealerCommentStyled';

export const DealerCommentStyledOV = styled(DealerCommentStyled)`
    .wrapper {
        .section {
            background: ${({ theme }) => theme.colors.grey10};
        }
    }
`;
